import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";


import { Col, Row } from "reactstrap";


export default function PlanningFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register } = formManager;//errors, control

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };


    register(bindPropResult);

    var frameClass = "d-inline-block";
    var frameStyle = {};
    var containerClass = "";

    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";

    var btnStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_planning");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
        }
        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) {
                //TEMP : Gestion décalage px/dp Android pour Home
                if (parentProps?.parentData?.groupSubName === "containerGroup" || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.groupSubName === "containerGroup") {
                    frameStyle.height = (parseFloat(design.height.replace("px", "")) * 2) + "px";
                }
                else {
                    frameStyle.height = design.height;
                }
            }
            else {
                frameClass += " h-100";
            }
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));
    }
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_planningInput", true);
    if (designInput) {
        Object.assign(btnStyle, modelFctManager.setCustomBackground(designInput, data));

        if (designInput.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
        if (designInput.fontSize) btnStyle.fontSize = designInput.fontSize;
        if (designInput.fontStyle) {
            if (designInput.fontStyle.indexOf("bold") >= 0) btnStyle.fontWeight = "bold";
            if (designInput.fontStyle.indexOf("italic") >= 0) btnStyle.fontStyle = "italic";
        }
    }

    //TODO
    //options >> data a charger dans la liste
    //extrasDesign.get("defaultItems") + default_planningItems
    //viewMode = arguments.view >> defaultView (agenda/listDay/listWeek/listMonth)
    //  >> onChange au changement de viewMode
    //click sur les items

    var rows = [];
    var fImage = [];
    var sImage = [];
    var fRow = [];
    var sRow = [];
    var tRow = [];

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => {
        if (child?.groupSubName?.startsWith("item")) {

            var cpt = modelFctManager.componentTyped(child, {
                ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false),
                stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup"))
            });

            if (child.groupSubName?.endsWith("firstImage")) fImage.push(cpt);
            else if (child.groupSubName?.endsWith("secondImage")) sImage.push(cpt);
            else if (child.groupSubName?.endsWith("first")) fRow.push(cpt);
            else if (child.groupSubName?.endsWith("second")) sRow.push(cpt);
            else if (child.groupSubName?.endsWith("third")) tRow.push(cpt);

            rows.push(cpt);
            return "";
        }
        else {
            return modelFctManager.componentTyped(child, {
                ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false),
                stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup"))
            });
        }
    }) || "";


    var rowSample = <Row style={{ borderBottom: "1px solid grey" }}>
        {fImage ? <Col xs="2">{fImage}</Col> : ""}
        <Col xs="8">
            <Row>
                <Col xs="12" className="text-primary">{fRow}</Col>
                <Col xs="12" className="text-success">{sRow}</Col>
                <Col xs="12" className="text-secondary">{tRow}</Col>
            </Row>
        </Col>
        {sImage ? <Col xs="2">{sImage}</Col> : ""}
    </Row>;

    var baseForm  = <div className={`${containerClass} ${formClass}`}>
        <Row className="justify-content-center">{childs}</Row>
        {data.arguments?.view?.startsWith("agenda") ? "AGENDA" :
            <>
                {rowSample}
                {rowSample}
            </>}
        
    </div>;

    //console.debug("render planning");

    return <Col data-name="PlanningFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}